import axios from 'axios';

const base = () => `${window.store.event_backend_api}/communications/sequences`;

export const listSequences = () =>
  axios.get(base()).then(({ data }) => data.data);

export const createSequence = (payload) =>
  axios.post(base(), payload).then(({ data }) => data.data);

export const updateSequence = (id, payload) =>
  axios.put(`${base()}/${id}`, payload).then(({ data }) => data.data);

export const deleteSequence = (id) => axios.delete(`${base()}/${id}`);

export const activateSequence = (id) =>
  axios.post(`${base()}/${id}/activate`).then(({ data }) => data.data);

export const deactivateSequence = (id) =>
  axios.post(`${base()}/${id}/deactivate`).then(({ data }) => data.data);
